(function ($, undefined) {

    $(document).ready(function(){

        $(".burger-menu ").on("click",".bar",function(){
            $(".burger-menu-content").css('top', $('.header_top').outerHeight()).slideToggle();

            $(".bar").toggleClass('change');
        });

        $('a[href*="#"]').on('click', function (e) {
          e.preventDefault()

          $('html, body').animate(
            {
              scrollTop: $($(this).attr('href')).offset().top-32,
            },
            500,
            'linear'
          )
        });

    });

})(jQuery);

